<div class="p-fluid w-[450px]" data-testid="document-upload-dialog">
  <form [formGroup]="form" (ngSubmit)="onSave()" class="flex flex-col gap-4">
    <app-form-field
      id="originalFilename"
      label="common.originalFilename"
      fieldName="originalFilename"
    ></app-form-field>

    <app-form-field
      id="fileName"
      label="common.fileName"
      fieldName="fileName"
      customErrorKey="error.azureDocument.invalidFileName.detail"
    ></app-form-field>

    <app-form-field id="version" label="common.version" fieldName="version"></app-form-field>

    @if (showStatus) {
      <app-form-field-select-button
        id="statusUuid"
        label="common.status"
        fieldName="statusUuid"
        [options]="uploadDocumentStatusOptions()"
        [isMandatory]="true"
      ></app-form-field-select-button>
    }

    <app-form-field-select-button
      id="visibility"
      label="provider.documents.upload.visibility"
      fieldName="visibility"
      [options]="visibilityOptions"
      [isMandatory]="true"
      [isReadOnly]="isVisibilityReadOnly()"
    ></app-form-field-select-button>

    <div class="flex justify-end gap-2">
      <p-button
        [label]="'common.cancel' | transloco"
        severity="secondary"
        (onClick)="onHideDialog()"
      ></p-button>
      @if (form.valid) {
        <p-button
          [label]="'common.apply' | transloco"
          type="submit"
          data-testid="document-upload-dialog-save"
        ></p-button>
      }
    </div>
  </form>
</div>
